@if (screenInfo$ | async; as screen) {
  <div style="display: flex; flex-direction: column; height: 100%">
    @if (isLoading) {
      <div
        style="flex: 1 0 100%; min-height: 0; display: flex; flex-direction: column; justify-content: space-between;">
        @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
          <sh-tabs id="spare-parts-tabs-1" style="width: 60%" condensed [collapsed]="screen.size === 'XSmall' || screen.size === 'Small' || screen.size === 'Medium'"
            >
            @for (tab of displayedTabs; track tab.name) {
              <sh-tab-item id="spare-parts-tab-item-2" disabled [active]="activeTab === tab.name"
              (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
            }
          </sh-tabs>
        }
        <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
          <sh-spinner id="spare-parts-spinner-3" site="s"></sh-spinner>
        </div>
      </div>
    }
    <sh-tooltip id="spare-parts-tooltip-days-since-the-same-spare" #tooltip target="icon-help"
    [attr.label]="'spareParts.tooltip.daysSinceLastReplaced' | transloco"></sh-tooltip>
    @if (!isLoading && parts) {
      <div style="flex: 1; min-height: 0;">
        <p-table [size]="'small'" #table [value]="parts" [scrollable]="true" scrollHeight="flex" [customSort]="true"
          (sortFunction)="customSort($event)" [sortField]="'date'" [sortOrder]="1">
          <!-- Tools -->
          <ng-template #caption style="border: none;">
            <div style="display: flex; align-items: center; gap: 8px;">
              @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
                <sh-tabs id="spare-parts-tabs-5" style="flex: 1 1 60%;" condensed [collapsed]="screen.size === 'XSmall' || screen.size === 'Small' || screen.size === 'Medium'"
                  >
                  @for (tab of displayedTabs; track tab.name) {
                    <sh-tab-item id="spare-parts-tab-item-6" [active]="activeTab === tab.name"
                    (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
                  }
                </sh-tabs>
              }
              <div class="table-tools" style="flex: 1 1 40%; gap: 8px; align-items: center;">
                <sh-dropdown id="spare-parts-dropdown-7" no-border condensed style="min-width: 100px; max-width: 140px;">
                  <sh-menu-item id="spare-parts-menu-item-last-30-days" (click)="changeRange(30,'serviceHistory')" [attr.label]="'msNotifications.range.last30Days' | transloco"
                  [active]="selectedRange === 30"></sh-menu-item>
                  <sh-menu-item id="spare-parts-menu-item-last-60-days" (click)="changeRange(60,'serviceHistory')" [attr.label]="'msNotifications.range.last60Days' | transloco"
                  [active]="selectedRange === 60"></sh-menu-item>
                  <sh-menu-item id="spare-parts-menu-item-last-90-days" (click)="changeRange(90,'serviceHistory')" [attr.label]="'msNotifications.range.last90Days' | transloco"
                  [active]="selectedRange === 90"></sh-menu-item>
                  <sh-menu-item id="spare-parts-menu-item-last-120-days" (click)="changeRange(120,'serviceHistory')" [attr.label]="'msNotifications.range.last120Days' | transloco"
                  [active]="selectedRange === 120"></sh-menu-item>
                  <sh-menu-item id="spare-parts-menu-item-last-365-days" (click)="changeRange(365,'serviceHistory')" [attr.label]="'msNotifications.range.last365Days' | transloco"
                  [active]="selectedRange === 365"></sh-menu-item>
                </sh-dropdown>
                <p-columnFilter style="flex: 0 1 210px;" type="text" [showMenu]="false" field="part"
                  matchMode="contains">
                  <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                    <sh-search id="spare-parts-search-search-for-part" no-border [attr.label]="'spareParts.filter.searchForPart' | transloco" condensed [(ngModel)]="searchTerm"
                    (ngModelChange)="filter($event)"></sh-search>
                  </ng-template>
                </p-columnFilter>
                <sh-divider id="spare-parts-divider-13" spacing='s' style="height: 30px;" vertical></sh-divider>
                <sh-icon id="spare-parts-icon-14" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
                @if (workareaSize !== 'fullscreen') {
                  <sh-icon id="spare-parts-icon-15" size="xs" [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'"
                  button (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                }
                <sh-icon id="spare-parts-icon-expand"  size="s" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" button (click)="onExpand($event)"></sh-icon>
                <sh-icon id="spare-parts-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
                [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              </div>
            </div>
          </ng-template>
          <!-- Header -->
          <ng-template #header>
            <tr>
              <th pSortableColumn="part" style="min-width:200px;" pFrozenColumn>
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'spareParts.table.part' | transloco }}
                  <p-sortIcon field="part" />
                </div>
              </th>
              @if (!isDeviceUI) {
                <th pSortableColumn="serial" style="min-width:150px;">
                  <div style="display: flex; gap: 6px; align-items: center;">
                    {{ 'spareParts.table.serialNumber' | transloco }}
                    <p-sortIcon field="serial" />
                  </div>
                </th>
              }
              <th pSortableColumn="date" style="min-width:125px;">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'spareParts.table.exchangeDate' | transloco }}
                  <p-sortIcon field="date" />
                </div>
              </th>
              <th pSortableColumn="life" style="min-width:75px; text-align: right">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'spareParts.table.medianLifetime' | transloco }}
                  <p-sortIcon field="life" />
                </div>
              </th>
              <th pSortableColumn="since" style="min-width:200px; text-align: right">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'spareParts.table.daysSinceLastReplaced' | transloco }}
                  <sh-icon style="display: inline-block;" id="icon-help" (mouseenter)="onHelpHover($event)"
                  (mouseleave)="handleMouseLeave($event)" size="xs" icon="confirmation" button></sh-icon>
                  <p-sortIcon field="since" />
                </div>
              </th>
              <th pSortableColumn="quantity" style="min-width:75px; text-align: right">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'spareParts.table.quantity' | transloco }}
                  <p-sortIcon field="quantity" />
                </div>
              </th>
              @if (!businessPartnerMode) {
                <th pSortableColumn="cost" style="min-width:75px; text-align: right">
                  <div style="display: flex; gap: 6px; align-items: center;">
                    {{ 'spareParts.table.cost' | transloco }}
                    <p-sortIcon field="cost" />
                  </div>
                </th>
              }
              <th pSortableColumn="noti" style="min-width:100px;">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'spareParts.table.notification' | transloco }}
                  <p-sortIcon field="noti" />
                </div>
              </th>
              <th alignFrozen="right" pFrozenColumn>{{ 'spareParts.table.action' | transloco }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-part>
            <tr>
              <td pFrozenColumn><span [innerHTML]="highlight(part.part)"></span></td>
              @if (!isDeviceUI) {
                <td>{{part.serial_number}}</td>
              }
              <td>{{part.movement_date?.replace("T"," ")?.replace("Z","")}}</td>
              <td style="text-align: right;">{{part.median_lifetime}}</td>
              <td>
                <div style="display: flex; gap: 7px; align-items: center; justify-content: flex-end;">
                  <sh-icon id="spare-parts-icon-warning" icon="warning" size="xs" color="#FBBF28"></sh-icon>
                  <span>{{part.days_since_last_used}}</span>
                </div>
              </td>
              <td style="text-align: right;">{{part.quantity}}</td>
              @if (!businessPartnerMode) {
                <td style="text-align: right;">{{part.cost.toFixed(2)}}</td>
              }
              <td>
                <div style="display: flex; gap: 6px;">
                  <sh-text id="spare-parts-text-18">{{part.noti_id}}</sh-text>
                </div>
              </td>
              <td alignFrozen="right" pFrozenColumn>
                <div style="display: flex; gap: 6px; justify-content: center; align-items: center;">
                  <sh-button id="spare-parts-button-how-to-replace" icon-position="left" icon="ai-generative" [ngClass]="'magic-button'" compact
                    [attr.label]="'spareParts.button.howToReplace' | transloco" size="m" color="tertiary"
                  (click)="askChat(part)"></sh-button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template #footer>
            @if (isDeviceUI) {
              <tr>
                <td colspan="4" pFrozenColumn>{{ 'spareParts.footer.totals' | transloco }}</td>
                <td class="font-bold" style="text-align: right;">{{ retrieveTotalQuantity() }}</td>
                @if (!businessPartnerMode) {
                  <td class="font-bold" style="text-align: right;">{{ retrieveTotalCost() }}</td>
                }
                <td colspan="2"></td>
              </tr>
            }
            @if (!isDeviceUI) {
              <tr>
                <td colspan="5" pFrozenColumn>{{ 'spareParts.footer.totals' | transloco }}</td>
                <td class="font-bold" style="text-align: right;">{{ retrieveTotalQuantity() }}</td>
                @if (!businessPartnerMode) {
                  <td class="font-bold" style="text-align: right;">{{ retrieveTotalCost() }}</td>
                }
                <td colspan="2"></td>
              </tr>
            }
          </ng-template>
          <ng-template pTemplate="emptymessage">
            @if (isDeviceUI) {
              <tr>
                <td colspan="7">
                  @if (!isError) {
                    <div
                      style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                      <sh-icon id="spare-parts-icon-warning" icon="warning" size="s"></sh-icon>
                      <span>{{ 'common.empty.noData' | transloco }}</span>
                    </div>
                  }
                  @if (isError) {
                    <div
                      style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                      <sh-icon id="spare-parts-icon-error" icon="error" size="s"></sh-icon>
                      <span>{{ 'common.empty.error' | transloco }}</span>
                    </div>
                  }
                </td>
              </tr>
            }
            @if (!isDeviceUI) {
              <tr>
                <td colspan="8">
                  @if (!isError) {
                    <div
                      style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                      <sh-icon id="spare-parts-icon-warning" icon="warning" size="s"></sh-icon>
                      <span>{{ 'common.empty.noData' | transloco }}</span>
                    </div>
                  }
                  @if (isError) {
                    <div
                      style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                      <sh-icon id="spare-parts-icon-error" icon="error" size="s"></sh-icon>
                      <span>{{ 'common.empty.error' | transloco }}</span>
                    </div>
                  }
                </td>
              </tr>
            }
          </ng-template>
        </p-table>
      </div>
    }
  </div>
}